import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'donationAmount';

export interface FormValues {
  donationAmount: number | null;
  maximizeDonations: boolean;
}

export const validation = yup.object().shape({
  maximizeDonations: yup.boolean().nullable(),
  donationAmount: yup
    .number()
    .nullable()
    .when('maximizeDonations', {
      is: false,
      then: yup
        .number()
        .nullable()
        .required('Please, enter a donation amount'),
    }),
});

export const MAXIMIZE_DONATIONS_TOOLTIP_CONTENT =
  'This maximizes the allowable Qualified Charitable Distribution (QCD) limits set by the IRS for each year in the specified donation range or uses the full Required Minimum Distribution (RMD) amount, whichever is lower.';
